import Vue from "vue";
import scrollIt from './helpers/scrollTo'

const dotationForm = () => {
  const donationBoxForm = document.querySelector('.donation_box--article');

  var globalResult;


  function paymentSucceed(response) {
    const form = document.querySelector('form.donation_box__inner');
    const newUrl = form.getAttribute('data-action');
    if (!form) {
      return;
    }

    const value      = response.value;
    const maskedCard = response.maskedCard;
    const tokenType  = response.tokenType;
    const type       = response.type;

    if (newUrl) {
      const parameters = `?value=${value}&maskedCard=${maskedCard}&tokenType=${tokenType}&type=${type}`
      var urlstr = '';
      for (let x in globalResult) {
        if (x.includes('app-'))
          urlstr += '&'+ x + '=' +globalResult[x];
      }
      // console.log(newUrl + parameters + urlstr);
      window.location = newUrl + parameters + urlstr;
    }
  }

  window.paymentSucceed = paymentSucceed;

  if (donationBoxForm) {
    new Vue({
      name: 'DonationBoxForm',
      el: donationBoxForm,
      data() {
        return {
          dotationValue: 50,
          inputValue: null,
          dotationValueValidation: false,
          name: null,
          secondName: null,
          email: null,
          nameValidation: false,
          secondNameValidation: false,
          emailValidation: false,
          formSending: false,
          mounted: false,
          formSendSuccess: false,
          formSendFailure: false,
          payType: null,
          step: 1,
        };
      },
      watch: {
        inputValue() {
          if (this.inputValue) {
            this.dotationValue = false;
            this.dotationValueValidation = false;
          } else if (!this.dotationValue) {
            this.dotationValue = 50;
          }
        },
        dotationValue() {
          if (this.dotationValue) {
            this.inputValue = null;
            this.dotationValueValidation = false;
          }
        },
        name() {
          if (this.name) {
            this.nameValidation = false;
          }
        },
        secondName() {
          if (this.secondName) {
            this.secondNameValidation = false;
          }
        },
        email() {
          if (this.email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const email = re.test(String(this.email).toLowerCase());
            if (email) {
              this.emailValidation = false;
            }
          }
        },
      },
      mounted() {
        const search = window.location.search;
        if (search) {
          const params = search.slice(1)
            .split('&')
            .map(p => p.split('='))
            .reduce((obj, pair) => {
              const [key, value] = pair.map(decodeURIComponent);
              return ({...obj, [key]: value})
            }, {});

          if ((params.dotationValue || params.inputValue) && params.payType) {
            this.step = 2;
            this.dotationValue = params.dotationValue;
            this.inputValue = params.inputValue;
            this.payType = params.payType;
          }
        }

        this.mounted = true;

      },
      methods: {
        pay(type) {
          this.payType = type;

          if (this.dotationValue || this.inputValue) {
            this.step = 2;
          } else {
            this.dotationValueValidation = true;
          }
        },
        clearURL() {
          history.pushState(null, '', window.location.pathname);
        },
        back(e) {
          this.step = 1;
          const btn = e.target;
          const body = btn.closest('body');
          this.clearURL();
          scrollIt(body, 300, 'easeOutQuad');
        },

        rodoValidation() {
          !this.rodo ? this.rodoValid = false : this.rodoValid = true;
        },

        submit(e) {
          e.stopPropagation();
          e.preventDefault();

          const btn = e.target;
          const form = btn.closest('form');
          const action = form.action;

          this.nameValidation = !this.name;
          this.secondNameValidation = !this.secondName;
          this.emailValidation = !this.email;

          if (!this.dotationValue && !this.inputValue || (!this.dotationValue && this.inputValue == 0)) {
            this.dotationValueValidation = true;
          }

          if (this.dotationValueValidation || this.nameValidation || this.secondNameValidation || this.emailValidation) {
            return;
          }

          const data = {
            'firstName': this.name,
            'lastName': this.secondName,
            'email': this.email,
            'amount': this.dotationValue ? this.dotationValue : this.inputValue,
            'recurring': this.payType ? false : true
          };

          var urlEncoded = [];
          for (var key in data) {
            if (data.hasOwnProperty(key)) {
              urlEncoded.push(key + '=' + encodeURIComponent(data[key]));
            }
          }

          const request = new Request(action + '?' + urlEncoded.join('&'), {
            method: 'GET',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            params: data
          });

          fetch(request).then(function (response) {
            return response.blob();
          }).then(function (response) {

            // create tag from string
            function createElementFromHTML(htmlString) {
              var div = document.createElement('div');
              div.innerHTML = htmlString.trim();
              return div.firstChild;
            }

            // read blob
            const reader = new FileReader();
            reader.addEventListener('loadend', (e) => {
              //console.log(e);

              const responseResult = JSON.parse(e.srcElement.result);

              globalResult = responseResult;

              // add script tag to DOM
              let script = document.createElement('script');

              script.src = responseResult['src'];

              // TODO: zapamiętać responseResult na później
              // TODO: ustawiać tylko te atrybuty które istnieją (wszystkie poza "src", i tymi zaczynającymi się od "app-")
              for (let x in responseResult) {
                if (x.includes('app-redirect-uri') && responseResult['app-redirect-uri']) {
                    window.location = responseResult['app-redirect-uri'];
                }
                if (!x.includes('app-') && !x.includes('src')){
                  script.setAttribute(x, responseResult[x]);
                }
              }

              document.getElementsByTagName('body')[0].appendChild(script);

              function payClick() {
                document.getElementById('pay-button').click();
              }

              setTimeout(payClick, 1000);
            });
            reader.readAsText(response);

            this.formSendSuccess = true;
            this.formSending = false;

          }).catch(() => {
            this.formSendFailure = true;
            this.formSending = false;
          });

          this.formSending = true;
        }
      }
    });
  }
};

export default dotationForm;



// WEBPACK FOOTER //
// ./assets/js/partials/dotationBoxForm.js